// extracted by mini-css-extract-plugin
module.exports = {"modal":"style_modal__11UZA"};